import React from "react";
import Card from "react-bootstrap/Card";
import Skeleton from "react-loading-skeleton";
import Image from "../../atoms/Image/Image";

import styles from "./brandCard.module.css";

const BrandCard = ({ brand = {}, ...props }) => {
  return (
    <div className={styles.card} {...props}>
      <div className={styles.image}>
        <Image variant="top" src={brand.logo} loading="lazy" alt={brand.name} />
      </div>
      <Card.Title>{brand.name}</Card.Title>
    </div>
  );
};

export const BrandCardSkelton = ({ ...props }) => {
  return (
    <div {...props} style={{ maxWidth: "220px" }}>
      <Skeleton height={140} />
      <Skeleton count={2} />
    </div>
  );
};
export default BrandCard;
